export const BILLING_TAB_PARAM = 'tab';

export const BILLING_TABS = {
  credit: 'credit',
  planBilling: 'plan-billing'
} as const;

export type BillingTab = typeof BILLING_TABS[keyof typeof BILLING_TABS];

export const DEFAULT_BILLING_TAB: BillingTab = BILLING_TABS.planBilling;

export function getBillingTab(tab: string | null): BillingTab {
  return tab === BILLING_TABS.credit ? BILLING_TABS.credit : DEFAULT_BILLING_TAB;
}

export function getBillingPath(tab: BillingTab = DEFAULT_BILLING_TAB): string {
  const searchParams = new URLSearchParams();

  if (tab !== DEFAULT_BILLING_TAB) {
    searchParams.set(BILLING_TAB_PARAM, tab);
  }

  const search = searchParams.toString();

  return `/settings/billing${search ? `?${search}` : ''}`;
}
